
import React from 'react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ArrowLeft, Users, Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Club } from '@/types/clubs';

interface ClubHeaderProps {
  club: Club;
  joiningClub: boolean;
  onJoinClub: () => void;
}

const ClubHeader: React.FC<ClubHeaderProps> = ({ club, joiningClub, onJoinClub }) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="mb-6 flex items-center">
        <Button variant="ghost" onClick={() => navigate('/clubs')} className="mr-2">
          <ArrowLeft size={16} className="mr-1" /> Back
        </Button>
        <h1 className="text-3xl font-bold">{club.name}</h1>
      </div>
      
      <div className="flex flex-wrap gap-2 mb-4">
        <Badge>{club.category}</Badge>
        <div className="flex items-center text-sm text-muted-foreground">
          <Users size={16} className="mr-1" /> {club.member_count} members
        </div>
        <div className="flex items-center text-sm text-muted-foreground">
          <Calendar size={16} className="mr-1" /> Created {new Date(club.created_at || '').toLocaleDateString()}
        </div>
      </div>
      
      <div className="mb-6">
        <Button 
          onClick={onJoinClub}
          disabled={joiningClub}
          variant={club.is_member ? "outline" : "default"}
          className="mr-2"
        >
          {joiningClub ? "Processing..." : (club.is_member ? "Leave Club" : "Join Club")}
        </Button>
      </div>
    </>
  );
};

export default ClubHeader;
